// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_cMZ","cls2":"RelatedPapersSidebar-cls2_Ghl RelatedPapersSidebar-cls1_cMZ"};